'use client';

import { Suspense } from 'react';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import '@/styles/headerfooter.css';
import ZapChat from '@/components/ZapChat';

import { PlanSelector } from '@/components/blocks/pricing/PlanSelector';

const pricingJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'ZappingAI Pricing',
  description:
    'Affordable AI generation plans  weekly/monthly/yearly. Generate AI videos, images, and more with ZappingAI.',
  url: 'https://zappingai.com/pricing',
};

export default function PricingPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pricingJsonLd) }}
      />
      <ZapChat />
      <main id="main-content" className="min-h-screen bg-[#212120]">
        <Suspense
          fallback={
            <div className="fixed top-0 right-0 left-0 z-50 h-[72px] border-white/5 border-b bg-transparent shadow-sm" />
          }
        >
          <Header />
        </Suspense>

        <div className="dark flex flex-col items-center pt-40 pb-20 text-white">
          <h1
            className="mb-12 text-center font-bold text-4xl tracking-tight md:text-5xl"
            style={{
              background: 'linear-gradient(135deg, #e2e8f0, #94a3b8)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Get Credits for Instant Access
          </h1>
          <div className="mt-12 flex w-full justify-center px-4">
            <PlanSelector />
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
}
